import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useParcours } from "../../context/ParcoursContext";

export default function ParcoursAssistStep() {
  const { parcoursId, stepId } = useParams<{ parcoursId: string; stepId: string }>();
  const navigate = useNavigate();
  const { markStepCompleted, isGuest } = useParcours();

  const handleMark = () => {
    if (!parcoursId || !stepId) return;
    if (isGuest) {
      alert("Connectez-vous pour marquer l'étape comme terminée.");
      return;
    }
    markStepCompleted(parcoursId, stepId);
  };

  return (
    <main className="max-w-4xl mx-auto py-8 px-4 space-y-4">
      <h1 className="text-2xl font-semibold">Réflexion guidée</h1>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Placeholder Assist : quelques questions pour stimuler la réflexion. L'IA sera branchée plus tard.
      </p>
      <ul className="list-disc list-inside text-sm text-slate-700 dark:text-slate-200 space-y-1">
        <li>Quand as-tu déjà ressenti le biais de confirmation ?</li>
        <li>Quelle source opposée pourrais-tu consulter pour nuancer ton avis ?</li>
        <li>Qu'as-tu appris aujourd'hui sur ta façon de filtrer l'information ?</li>
      </ul>
      <div className="flex gap-2">
        <button
          type="button"
          className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-sm font-semibold"
          onClick={handleMark}
        >
          Étape terminée
        </button>
        <button
          type="button"
          className="px-4 py-2 rounded-lg border text-sm font-semibold"
          onClick={() => navigate(`/parcours/${parcoursId}`)}
        >
          Revenir au parcours
        </button>
      </div>
      {/* TODO MixMind: brancher une interface Assist IA et la sauvegarde des réponses. */}
    </main>
  );
}
